export const ES = {
  Seja_bem_vindo_ao_nosso_portal: "Bienvenido a nuestro portal",
  Cooperado: "Cooperado",
  Faca_seu_login: "Inicie sesión",
  Esqueci_minha_senha: "Olvidé mi contraseña",
  Usuario: "Usuario",
  Entrar: "Entrar",
  Esqueceu_a_senha: "¿Olvidó la contraseña?",
  Vamos_enviar_a_recuperação_de_senha_para_seu_email_cadastrado_tudo_bem:
    "Enviaremos la recuperación de contraseña a su correo electrónico registrado, ¿de acuerdo?",
  Caso_voce_nao_possua_mais_acesso_ao_email_vinculado_a_sua_conta_entre_em_contato_com_o_suporte:
    "Si ya no tiene acceso al correo electrónico vinculado a su cuenta, comuníquese con el soporte.",
  Enviar: "Enviar",
  Recuperar_senha: "Recuperar contraseña",
  Digite_o_email_associado_a_sua_conta:
    "Ingrese el correo electrónico asociado a su cuenta",
  E_mail: "Correo electrónico",
  Continental_2025___Todos_os_direitos_reservados:
    "Continental 2025 - Todos los derechos reservados",
  Confirmacao: "Confirmación",
  Vamos_enviar_a_recupera_o_de_senha_para_seu_e_mail_tudo_bem:
    "Enviaremos la recuperación de contraseña a su correo electrónico, ¿de acuerdo?",
  Confirme_abaixo_o_e_mail_cadastrado:
    "Confirme abajo el correo electrónico registrado",
  E_mail_invalido: "Correo electrónico no válido",
  Alterar_a_sua_senha: "Cambiar su contraseña",
  Vamos_cadastrar_sua_senha: "Vamos a registrar su contraseña",
  Usuario_invalido: "Usuario no válido",
  Codigo_invalido: "Código no válido",
  Confirmar_senha: "Confirmar contraseña",
  Forca_da_sua_senha: "Fuerza de su contraseña",
  Conter_no_m_nimo_8_caracteres: "Contener al menos 8 caracteres",
  Conter_numeros: "Contener números",
  Conter_letras_maiusculas_e_minusculas:
    "Contener letras mayúsculas y minúsculas",
  Conter_caracteres_especiais: "Contener caracteres especiales",
  Confirmacao_de_senha_igual: "Confirmación de contraseña igual",
  Fraca: "Débil",
  Media: "Media",
  Forte: "Fuerte",
  Inicio: "Inicio",
  Processos: "Procesos",
  Aprovacao_de_verba: "Aprobación de presupuesto",
  Comprovacao: "Comprobación",
  Financeiro: "Financiero",
  Midia_center: "Centro de medios",
  Galeria_de_midia: "Galería de medios",
  Editor_de_templates: "Editor de plantillas",
  Cadastros: "Registros",
  Gestao_de_processos: "Gestión de procesos",
  Política_de_accrual: "Política de acumulación",
  Banners: "Banners",
  Banner: "Banner",
  Noticias: "Noticias",
  Notificacoes: "Notificaciones",
  Prazos: "Plazos",
  Relatorios: "Informes",
  Fale_conosco: "Contáctenos",
  Portal: "Portal",
  Meu_cadastro: "Mi registro",
  Ausencia_temporaria: "Ausencia temporal",
  Sair: "Salir",
  Ola: "Hola",
  Bem_vindo_ao_portal_do_administrador:
    "Bienvenido al portal del administrador",
  Voce_possui: "Usted tiene",
  Mensagens_nao_lidas: "Mensajes no leídos",
  Consulta: "Consulta",
  Rapida: "Rápida",
  Buscar: "Buscar",
  Resultados: "Resultados",
  Ano: "Año",
  Mes: "Mes",
  Revenda: "Reventa",
  Status: "Estado",
  Faca_sua_pesquisa: "Haga su búsqueda",
  Digite_aqui_para_pesquisar: "Escriba aquí para buscar",
  Numero_solicitacao: "Nº Solicitud",
  Data_hora_de_criacao: "Fecha/Hora de creación",
  Acao: "Acción",
  Campanha: "Campaña",
  Visualizar: "Visualizar",
  Editar: "Editar",
  Excluir: "Eliminar",
  Detalhes: "Detalles",
  Fechar: "Cerrar",
  Ultimas_noticias: "ÚLTIMAS NOTICIAS",
  Saiba_mais: "SABER MÁS",
  Voltar: "Volver",
  Aprovacao_de_Verba: "Aprobación de Presupuesto",
  Verba: "Presupuesto",
  Area_para_acompanhamento_das_comprovacoes:
    "Área para el seguimiento de comprobaciones",
  Area_para_acompanhamento_das_solicitacoes_de_verba:
    "Área para el seguimiento de solicitudes de presupuesto",
  Selecione: "Seleccione",
  Solicitacao_de_Verba: "Solicitud de Presupuesto",
  Grupo: "Grupo",
  Grupos: "Grupos",
  Regiao: "Región",
  Segmento: "Segmento",
  Revenda: "Revenda",
  Status: "Status",
  Minhas_pendencias: "Mis pendientes",
  Em_andamento: "En progreso",
  Reiniciadas: "Reiniciadas",
  Aprovadas: "Aprobadas",
  Reprovadas: "Rechazadas",
  Finalizadas: "Finalizadas",
  As_solicitacoes_abaixo_aguardam_uma_acao_sua:
    "Las solicitudes a continuación esperan una acción suya",
  Data_de_Inicio: "Fecha de Inicio",
  Tipo_de_Acao: "Tipo de Acción",
  Valor_Estimado: "Valor Estimado",
  Valor_Reembolso: "Valor de Reembolso",
  Aprovar_selecionados: "Aprobar seleccionados",
  Transferir_Verba: "Transferir Presupuesto",
  Transferencia_de_Verba: "Transferencia de Presupuesto",
  Tipo_de_Transferencia: "Tipo de Transferencia",
  Tipo_de_prazo: "Tipo de prazo",
  Selecione_tipo_de_prazo: "Selecione tipo de prazo",
  Inserir_data: "Insertar fecha",
  Fim: "Fin",
  Siga_nossas_redes_sociais: "Siga nuestras redes sociales",
  Atencao_Percentual_de_Reembolso:
    "¡Atención! Porcentaje de reembolso informado manualmente por la Reventa. No sigue la Política de Acumulación vigente para el período",
  Documentos: "Documentos",
  Data_e_Hora_de_criacao: "Fecha y Hora de creación",
  Ano_da_competencia: "Año de la competencia",
  Mes_da_competencia: "Mes de la competencia",
  ProcessoN: "Proceso Nº",
  Dados_do: "Datos del",
  Dados_da: "Datos de la",
  Solicitante: "Solicitante",
  Etapas_do: "Etapas del",
  Processo: "Proceso",
  CnpjCuit: "CNPJ/CUIT",
  Razao_Social: "Razón Social",
  Responsavel_loja: "Responsable de la tienda (Nombre)",
  Responsavel_Continental: "Responsable Continental",
  Canal_de_venda: "Canal de venta",
  Categoria_de_reembolso: "Categoría de reembolso",
  Tipo_de_reembolso: "Tipo de reembolso",
  Valor_previsto_para_reembolso: "Valor previsto para reembolso",
  Porcentagem_de_reembolso: "Porcentaje de reembolso (%)",
  Informar_percentual_manualmente: "Informar porcentaje manualmente",
  Uf: "UF",
  Cidade_de_vigencia: "Ciudad de vigencia",
  Descricao_da_acao: "Descripción de la acción",
  Sim: "Sí",
  Nao: "No",
  Justificativa: "Justificación",
  Aprovacao_de: "Aprobación de",
  Documentacao_solicitada: "Documentación solicitada",
  Arquivo_solicitado: "Archivo solicitado",
  Baixar: "Descargar",
  Retornar_verba: "Devolver presupuesto",
  Aprovar: "Aprobar",
  Reprovar: "Reprobar",
  Historico: "Historial",
  Data_Hora: "Fecha/Hora",
  Observacao: "Observación",
  Resetar_Verba: "Restablecer Presupuesto",
  Selecione_para_quem_deseja_retornar_a_verba:
    "Seleccione a quién desea devolver el presupuesto",
  Usuarios_cadastrados: "Usuarios registrados",
  Resetar: "Restablecer",
  Anexar_arquivo: "Adjuntar archivo",
  Reprovacao: "Rechazo",
  Confirmar: "Confirmar",
  Modulo_para_gestao_de_credito_de_reembolso:
    "Módulo para la gestión de créditos de reembolso",
  Importar_pagamentos: "Importar pagos",
  Total_solicitado: "Total solicitado",
  Total_aprovado_para_execucao: "Total aprobado para ejecución",
  Total_executado: "Total ejecutado",
  Total_creditado: "Total acreditado",
  Total_pendente: "Total pendiente",
  Valores_finais_de_reembolso: "(*) Valores finales de reembolso",
  Cadastro: "Registro",
  Gerencie_usuarios_vendas_e_configuracoes_gerais_do_portal:
    "Gestione usuarios, ventas y configuraciones generales del portal",
  Revendas: "Reventas",
  Usuarios: "Usuarios",
  Configuracoes: "Configuraciones",
  Cadastrar_novo_usuario: "Registrar nuevo usuario",
  Importar_base_de_usuarios: "Importar base de usuarios",
  Nome_ou_Login: "Nombre o Usuario",
  Perfil_de_acesso: "Perfil de acceso",
  Cadastrar_nova_revenda: "Registrar nueva reventa",
  Importar_base_de_revendas: "Importar base de reventas",
  Importar_Mystery_Shopper: "Importar Mystery Shopper",
  Codigo_CNPJ_ou_Razao_Social: "Código, CNPJ o Razón Social",
  Cnpj: "CNPJ",
  Classificacao_atual_Mystery_Shopper: "Clasificación actual Mystery Shopper",
  Nome: "Nombre",
  Login: "Usuario",
  Configuracao: "Configuración",
  Dados_Pessoais: "Datos Personales",
  Nome_obrigatorio: "Nombre obligatorio",
  Email: "Correo electrónico",
  Email_invalido: "Correo electrónico inválido",
  Login_invalido: "Usuario inválido",
  Perfil_de_acesso_invalido: "Perfil de acceso inválido",
  Departamento_invalido: "Departamento inválido",
  Cargo_invalido: "Cargo inválido",
  Senha: "Contraseña",
  Senha_invalido: "Contraseña inválida",
  Cargo: "Cargo",
  Telefone: "Teléfono",
  Departamento: "Departamento",
  Ativo: "Activo",
  Inativo: "Inactivo",
  Salvar: "Guardar",
  Dados_da_Revenda: "Datos de la Reventa",
  Cnpj_obrigatorio: "CNPJ/CUIT obligatorio",
  Codigo_SAP_invalido: "Código SAP inválido",
  Codigo_Sap: "Código SAP",
  Razao_Social_invalida: "Razón Social inválida",
  Nome_Fantasia: "Nombre Fantasía",
  Nome_Fantasia_invalido: "Nombre Fantasía inválido",
  Departamentos: "Departamentos",
  Cargos: "Cargos",
  Canais_de_Venda: "Canales de Venta",
  Segmentos: "Segmentos",
  Campanhas: "Campañas",
  Tipos_de_Acao: "Tipos de Acción",
  Regioes: "Regiones",
  Adicionar_perfil_de_acesso: "Agregar perfil de acceso",
  Adicionar_tipo_de_acao: "Agregar tipo de acción",
  Adicionar: "Agregar",
  Data_hora_de_alteracao: "Fecha/Hora de modificación",
  Total_de_cadastros: "Total de registros",
  DescricaoToolTips: "Descripción (tooltips)",
  Total_de_processos: "Total de procesos",
  Ativar: "Activar",
  Inativar: "Desactivar",
  Perfil_de_acesso_obrigatorio: "Perfil de acceso obligatorio",
  Defina_os_parametros_da_configuracao_selecionada:
    "Defina los parámetros de la configuración seleccionada.",
  Home: "Inicio",
  Aprovacao_de_verba: "Aprobación de presupuesto",
  Editor_de_templates: "Editor de plantillas",
  Admin: "Administrador",
  Acessa_portal: "Accede al portal",
  Acessa_admin: "Accede al administrador",
  Canceladas: "Canceladas",
  Pagina: "Página",
  Todos: "Todos",
  Criar: "Crear",
  Politica_de_accrual: "Política de acumulación",
  Faca_aqui_a_gestao_das_politicas_de_accrual:
    "Gestione aquí las políticas de acumulación",
  Configuracao_de_: "Configuración de",
  Reembolso: "reembolso",
  Adicionar_nivel_de_classificacao: "Agregar nivel de clasificación",
  Semestre: "Semestre",
  Vigencia_da: "Vigencia de la",
  Politica: "Política",
  Data_inicial_da_vigencia: "Fecha inicial de vigencia",
  Data_final_da_vigencia: "Fecha final de vigencia",
  Nivel: "Nivel",
  Categoria_de_Reembolso: "Categoría de Reembolso",
  Gestao_de_Banners: "Gestión de Banners",
  Gerencie_os_banners_que_serao_exibidos_na_pagina_inicial:
    "Gestione los banners que se mostrarán en la página inicial",
  Novo_Banner: "Nuevo Banner",
  Data_de_Termino: "Fecha de Finalización",
  Indeterminado: "Indeterminado",
  Inserir_nome: "Ingresar nombre",
  Selecionar_tipo_de_prazo: "Seleccionar tipo de plazo",
  Excluir_arte_do_banner: "Eliminar arte del banner",
  Importar_arte_do_banner: "Importar arte del banner",
  Formatos_aceitos_jpeg_jpg_png: "Formatos aceptados: jpeg, jpg, png",
  Tamanho_recomendado_1920px_x_500px:
    "El tamaño recomendado para banners es de 1920px x 500px",
  Alterar: "Modificar",
  Gestao_de_Noticias: "Gestión de Noticias",
  Gerencie_as_noticias_que_serão_exibidas_na_pagina_inicial:
    "Gestione las noticias que se mostrarán en la página inicial",
  Nova_Noticia: "Nueva Noticia",
  Tisub_tulo: "Título",
  Descricao: "Descripción",
  Excluir_arte_da_noticia: "Eliminar arte de la noticia (PORTADA)",
  Importar_arte_da_noticia: "Importar arte de la noticia (PORTADA)",
  Excluir_arte_da_noticia_principal: "Eliminar arte de la noticia (PRINCIPAL)",
  Importar_arte_da_noticia_principal: "Importar arte de la noticia (PRINCIPAL)",
  Gestao_de_Notificacoes: "Gestión de Notificaciones",
  Envie_mensagens_para_os_usuarios: "Envíe mensajes a los usuarios",
  Enviar_nova_notificacao: "Enviar una nueva notificación",
  Destinatarios: "Destinatarios",
  Configuracao_de_prazos_Revendas: "Configuración de plazos (Reventas)",
  Defina_aqui_os_prazos_para_inclusao_de_verba_e_comprovacao:
    "Defina aquí los plazos para inclusión de presupuesto y comprobación",
  Selecione_o: "Seleccione el",
  Informe_a: "Informe la",
  Data_limite: "Fecha límite",
  Alterar_Todos: "Modificar todos",
  E_Em_Seguida: "y a continuación",
  Nova_Data: "Nueva Fecha",
  Relatorios: "Informes",
  Escolha_Um: "Elija uno",
  Tipo_de_Relatorio: "Tipo de informe",
  E_na_sequencia_preencha_todos_os_campos_para_exportar_um_relatorio:
    "y luego complete todos los campos para exportar un informe",
  Exportar_relatorio: "Exportar informe",
  Cadastro_de_usuarios: "Registro de usuarios",
  Cadastro_de_revenda: "Registro de reventa",
  Comprovacao: "Comprobación",
  Log_de_acessos: "Registro de accesos",
  Log_de_registros: "Registro de registros",
  Mystery_Shopper: "Mystery Shopper",
  Templates: "Plantillas",
  Faca_aqui_o_acaompanhamento_dos_chamados_de_fale_conosco:
    "Haga aquí el seguimiento de los llamados de contacto",
  Assunto: "Asunto",
  Motivo: "Motivo",
  Protocolo: "Protocolo",
  Reclamante: "Reclamante",
  Dias_na_fila: "Días en la fila",
  N_de_interacoes: "Nº de interacciones",
  Finalizadas: "Finalizadas",
  Finalizados: "Finalizados",
  Detalhes_do: "Detalles de",
  Chamado: "Llamado",
  Historico_de: "Historial de",
  Interacoes: "Interacciones",
  Resposta: "Respuesta",
  Hora_de_retorno: "Hora de regreso",
  Data_de_retorno: "Fecha de regreso",
  Anexar_arquivo_maximo_5mb: "Adjuntar archivo, máximo (5mb)",
  Encerrar_chamado: "Cerrar llamado",
  Perfil_de_acesso_invalido: "Perfil de acceso inválido",
  Departamento_inválido: "Departamento inválido",
  Cargo_inválido: "Cargo inválido",
  Confirmar_senha: "Confirmar contraseña",
  Ausencia_Temporaria: "Ausencia Temporal",
  Ativar_Ausencia_Temporaria: "Activar ausencia temporal",
  Selecionar_Ausencia_Temporaria: "Seleccionar ausencia temporal",
  Selecionar_tipo_de_prazo: "Seleccionar tipo de plazo",
  Selecione_o_usuario_que_devera_receber_os_processos_durante_o_periodo_informado:
    "Seleccione el usuario que deberá recibir los procesos durante el período informado",
  Durante_o_periodo_informado_o_usuario_selecionado_tera_acesso_a_todos_os_processos_em_seu_nome_As_notificacoes_ficarao_desativadas:
    "Durante el período informado, el usuario seleccionado tendrá acceso a todos los procesos en su nombre. Las notificaciones estarán desactivadas.",
  Administrador_cadastrado_com_sucesso: "Administrador registrado con éxito",
  Administrador_alterado_com_sucesso: "Administrador modificado con éxito",
  Banner_cadastrado_com_sucesso: "Banner registrado con éxito",
  Banner_alterado_com_sucesso: "Banner modificado con éxito",
  Tamanho_recomendado_para_banners_e_de_1920px_x_500px:
    "El tamaño recomendado para banners es de 1920px x 500px",
  Cadastrado_com_sucesso: "Registrado con éxito",
  Editado_com_sucesso: "Editado con éxito",
  Cadastro_alterado_com_sucesso: "Registro modificado con éxito",
  Processo_encaminhado_para_aprovacao_com_sucesso:
    "Proceso enviado para aprobación con éxito",
  Aprovado_com_sucesso: "Aprobado con éxito",
  Alterado_com_sucesso: "Modificado con éxito",
  Verifique_seu_email: "Verifique su correo electrónico",
  Transferencia_realizada: "Transferencia realizada",
  Noticia_cadastrada_com_sucesso: "Noticia registrada con éxito",
  Noticia_alterada_com_sucesso: "Noticia modificada con éxito",
  Notificacao_alterada_com_sucesso: "Notificación modificada con éxito",
  Notificacao_cadastrada_com_sucesso: "Notificación registrada con éxito",
  Participante_cadastrado_com_sucesso: "Participante registrado con éxito",
  Participante_alterado_com_sucesso: "Participante modificado con éxito",
  CPF_nao_encontrado: "CPF no encontrado",
  Politica_de_Accrual_cadastrada_com_sucesso:
    "Política de Accrual registrada con éxito",
  Politica_de_Accrual_publicada_com_sucesso:
    "Política de Accrual publicada con éxito",
  Todas_datas_de_prazo_foram_alteradas_com_sucesso:
    "Todas las fechas de plazo fueron modificadas con éxito",
  Politica_de_Accrual_alterada_com_sucesso:
    "Política de Accrual modificada con éxito",
  Importacao: "Importación",
  Tipo_de_importacao: "Tipo de importación",
  Escolher_arquivo: "Elegir archivo",
  Importar_arquivo: "Importar archivo",
  Baixar_modelo: "Descargar modelo",
  Selecione_um_tipo_de_importacao: "Seleccione un tipo de importación",
  Para_fazer_o_upload_em_massa_do_seu_estoque_siga_as_orientacoes_abaixo:
    "Para subir en masa su inventario, siga las indicaciones a continuación",
  Clique_em_Baixar_Modelo_para_fazer_o_download_da_planilha_de_importacao:
    "Haga clic en 'Descargar modelo' para descargar la hoja de importación",
  A_planilha_deve_estar_no_formato_xlsx: "La hoja debe estar en formato .xlsx",
  O_arquivo_nao_deve_conter_celulas_mescladas:
    "El archivo no debe contener celdas combinadas",
  A_primeira_linha_deve_conter_o_cabecalho_das_colunas:
    "La primera línea debe contener el encabezado de las columnas",
  Deve_haver_somente_uma_aba_no_arquivo:
    "Debe haber solo una pestaña en el archivo",
  Apos_a_importacao_veja_o_resultado_de_cada_registro_clicando_nos_numeros_processados:
    "Después de la importación, vea el resultado de cada registro haciendo clic en los números procesados",
  No_caso_de_erro_no_upload_sera_gerada_uma_planilha_com_o_descritivo_do_erro_de_leitura_na_ultima_coluna_Favor_consultar_ajustar_e_carregar_novamente:
    "En caso de error en la carga, se generará una hoja con la descripción del error de lectura en la última columna. Por favor, consulte, ajuste y cargue nuevamente.",
  Log_de: "Registro de",
  Tipo: "Tipo",
  Arquivo: "Archivo",
  Total: "Total",
  Ok: "Ok",
  Duplicado: "Duplicado",
  Erro: "Error",
  Vendas_de_total: "Ventas del total",
  Log_de_duplicados: "Registro de duplicados",
  Log_de_erros: "Registro de errores",
  Log_de_sucesso: "Registro de éxito",
  Orientacoes: "Orientaciones",
  Alterar_data: "Cambiar fecha",
  Voce_nao_tem_permissao_para_acessar_esta_pagina:
    "No tiene permiso para acceder a esta página",
  Voce_nao_tem_permissao: "No tiene permiso",
  Gestao_de_processos: "Gestión de procesos",
  Configure_e_gerencie_aqui_os_workflows_de_aprovacao:
    "Configure y gestione aquí los flujos de aprobación",
  Adicionar_processo_de_aprovacao: "Agregar proceso de aprobación",
  Data_e_Hora: "Fecha y hora",
  Configuracao_de_Etapas: "Configuración de etapas",
  De_Aprovacao: "de aprobación",
  Novo_Processo: "Nuevo proceso",
  Nome_do_Processo: "Nombre del proceso",
  Aprovacao_de_verba: "Aprobación de presupuesto",
  Consultor_Supervisor: "Consultor/Supervisor",
  Presidente: "Presidente",
  Extra: "Extra",
  Tetos_de_aprovacao: "Límites de aprobación",
  Diretor_Maior_ou_Igual: "DIRECTOR (Mayor o igual)",
  Presidente_Maior_ou_Igual: "PRESIDENTE (Mayor o igual)",
  Marketing: "Marketing",
  Gerente: "Gerente",
  Diretor: "Director",
  Lista_vazia: "Lista vacía",
  Usuarios_selecionados: "Usuarios seleccionados",
  SLA_da_etapa_dias: "SLA de la etapa (días)",
  Tipo_de_Acao_Obrigatoria: "Tipo de acción obligatoria",
  midia: "Medios",
  Tipo_de_midia_Obrigatoria: "Tipo de medio obligatorio",
  Tipo_de_midia: "Tipo de medio",
  Tipo_de: "Tipo de",
  Janeiro: "Enero",
  Fevereiro: "Febrero",
  Marco: "Marzo",
  Abril: "Abril",
  Maio: "Mayo",
  Junho: "Junio",
  Julho: "Julio",
  Agosto: "Agosto",
  Setembro: "Septiembre",
  Outubro: "Octubre",
  Novembro: "Noviembre",
  Dezembro: "Diciembre",
  Numero_de_processos: "Número de procesos",
  Bem_vindo_ao_portal_da_revenda: "Bienvenido(a) al portal de la tienda",
  Ver_mais_Noticias: "Ver más Noticias",
  Marcar_como_lido: "Marcar como leído",
  Ver_mais: "VER MÁS",
  Comprovacao_de_despesas: "Comprobación de gastos",
  Solicitacao_de_verba: "Solicitud de fondos",
  Acompanhe_o_andamento_das_suas_comprovacoes:
    "Siga el progreso de sus comprobaciones",
  Acompanhe_o_andamento_as_suas_solicitacoes:
    "Siga el progreso de sus solicitudes",
  Total_Creditado: "Total acreditado",
  Total_Pendente: "Total pendiente",
  Nova_Solicitacao: "Nueva Solicitud",
  Rascunho: "Borrador",
  Conteudo_a_ser_veiculado: "Contenido a ser difundido",
  Orcamento: "Presupuesto",
  Outros: "Otros",
  Documentação_solicitada: "Documentación solicitada",
  Documentos_especificos: "Documentos específicos",
  Nota_Fiscal: "Factura",
  Comprovante_de_Midia: "Comprobante de Medio",
  Comprovacao_de: "Comprobación de",
  Atencao_Sera_permitido_apenas_1_anexo_por_documentacao_solicitada_Caso_o_volume_de_arquivos_seja_superior_salve_em_zip:
    "¡Atención! Solo se permitirá un archivo adjunto por documentación solicitada. Si el volumen de archivos es mayor, guarde en .zip",
  Para_uma_melhor_experiencia_nao_realize_upload_de_arquivos_superiores_a_5MB:
    "Para una mejor experiencia, no suba archivos superiores a 5 MB",
  Salvar_como_rascunho: "Guardar como borrador",
  Enviar_para_aprovacao: "Enviar para aprobación",
  Anexar: "Adjuntar",
  Cadastre_se: "Regístrate",
  Vamos_la: "¿Vamos allá?",
  Comece_Informando_o_CNPJ_da_sua_Revenda:
    "Comienza proporcionando el CNPJ de tu tienda",
  Prosseguir: "Continuar",
  Precisamos_agora_que_informe_o_seu_email_ok:
    "Ahora necesitamos que nos proporciones tu correo electrónico, ¿está bien?",
  Informe_seu_email: "Proporcione su correo electrónico",
  Muito_obrigado: "¡Muchas gracias!",
  Agora_precisamos_saber_um_pouco_mais_sobre_voce:
    "¡Ahora necesitamos saber un poco más sobre ti!",
  Nome_Completo: "Nombre Completo",
  Telefone_invalido: "Teléfono inválido",
  E_pra_terminar: "Y para terminar :)",
  Vamos_cadastrar_sua_senha: "Vamos a registrar tu contraseña:",
  Usuario_Login: "Usuario (login)",
  Parabens: "¡Felicidades!",
  Sua_conta_foi_criada_com_sucesso: "Tu cuenta ha sido creada con éxito.",
  Voce_podera_alterar_seus_dados_aqualquer_momento:
    "Puedes cambiar tus datos en cualquier momento en",
  Meu_Cadastro: "Mi Registro",
  Ir_para_o_portal: "Ir al portal",
  Voce_entrara_no_portal_em: "Entrarás al portal en:",
  Codigo: "Código",
  Insercao_da_Acao: "Inserción de la Acción\n(Revendedor)",
  Aprovacao_Consultor: "Aprobación\nConsultor",
  Gerente_Regional: "Gerente\nRegional",
  Credito_liberado: "Crédito\nliberado",
  Insercao_da_Acao_Revendedor: "Inserción de la Acción\n(Revendedor)",
  Aprovacao_Continental: "Aprobación\nContinental",
  Aprovado_excucao: "Aprobado para\nEjecución",
  Comprovacao_da_despesa_revendedor: "Comprobación de Gastos\n(Revendedor)",
  Pagamento_do_Reembolso: "Pago de\nReembolso",
  Consulte_as_politicas_vigentes: "Consulte aquí las políticas vigentes",
  Politica_vigente_para_verbas_inseridas_no_portal_no_periodo_de:
    "Política vigente para fondos insertados en el portal en el período de:",
  Ate: "hasta",
  Abrir_um_novo_chamado: "Abrir un nuevo llamado",
  Codigo_do_Cliente: "Código del cliente",
  Para_facilitar_suas_solicitações_e_consultas_selecione_as_filiais_para_as_quais_pretende_realizar_ações:
    "Para facilitar sus solicitudes y consultas, seleccione las filiales para las cuales desea realizar acciones:",
  O_CNPJ_informado_faz_parte_de_um_grupo_com_outros_CNPJs_vinculados:
    "El CNPJ informado forma parte de un grupo con otros CNPJs vinculados",
  Deseja_adicionar_todas_as_filiais_do_grupo_para_este_usuario:
    "¿Desea agregar todas las filiales del grupo para este usuario?",
  Relatorio_de_comprovacao: "Informe de comprobación",
  Relatorio_de_aprovacao: "Informe de aprobación",
  Relatorio_de_fale_conosco: "Informe de contáctenos",
  Relatorios_de_financas: "Informes de finanzas",
  Relatorio_de_usuarios: "Informe de usuarios",
  Relatorio_de_revendas: "Informe de tiendas",
  Ausencia_criada_com_sucesso: "¡Ausencia creada con éxito!",
  Ausencia_encerrada_com_sucesso: "¡Ausencia cerrada con éxito!",
  Midia_center: "Media Library",
  Participante: "Participante",
  Administrador: "Administrador",
  Dashboard: "Panel de control",
  Log: "Registro",
  Nao_ha_notificacoes: "No hay notificaciones",
  Perfil: "Perfil",
  Galeria_de_Midia_M: "GALERÍA DE MEDIOS",
  Midia: "Medios",
  Center: "Centro",
  Atividades_Recentes: "Actividades recientes",
  Favoritos: "Favoritos",
  Lixeira: "Papelera",
  Itens_Cometilhados: "Elementos Compartidos",
  Links: "Enlaces",
  Pastas_Compartilhadas: "Carpetas compartidas",
  Adicionar_pasta: "Agregar carpeta",
  Fazer_upload: "Subir archivo",
  Compartilhar_Pasta: "Compartir carpeta",
  Criar_novo_link: "Crear nuevo enlace",
  Nova_pasta_compartilhada: "Nueva carpeta compartida",
  Visualizacao: "Visualización",
  Selecionar_todos: "Seleccionar todos",
  Efetuar_download: "Realizar descarga",
  Copiar: "Copiar",
  Mover: "Mover",
  Classificacao: "Clasificación",
  Tamanho: "Tamaño",
  Tipo: "Tipo",
  Data_do_descarte: "Fecha de descarte",
  Usuario_que_inativou: "Usuario que desactivó",
  Classificacao_alterada_com_sucesso: "¡Clasificación cambiada con éxito!",
  Autor: "Autor",
  Data_de_inclusao: "Fecha de inclusión",
  Dono: "Dueño",
  Acesso: "Acceso",
  Compartilhado_em: "Compartido en",
  Data_do_compartilhamento: "Fecha del compartimiento",
  Compartilhado_com: "Compartido con",
  Data_Fim: "Fecha de fin",
  Mostrando: "Mostrando",
  de: "de",
  ate: "hasta",
  registros: "registros",
  Abrir: "Abrir",
  Info: "Info",
  Remover_favorito: "Eliminar de favoritos",
  Fazer_download: "Realizar descarga",
  Gerenciar_link: "Gestionar enlace",
  Obter_link: "Obtener enlace",
  Remover_link: "Eliminar enlace",
  Renomear: "Renombrar",
  Remover: "Eliminar",
  Compartilhar: "Compartir",
  Nova_pasta: "Nueva carpeta",
  Publicar_para_mim: "Publicar para mí",
  Publicar_para_todos: "Publicar para todos",
  Nome_da_pasta: "Nombre de la carpeta",
  Cancelar: "Cancelar",
  Pesquisar_pasta: "Buscar carpeta",
  Pesquisar_arquivo: "Buscar archivo",
  Upload_em_andamento: "Subida en curso",
  Finalizando_o_upload: "Finalizando la subida",
  Destino: "Destino",
  Nuvem_de_arquivos: "Nube de archivos",
  Arquivos_Importados: "Archivos importados",
  Identificamos_arquivos_com_mesmo_nome_na_pasta_de_destino:
    "Hemos identificado archivo(s) con el mismo nombre en la carpeta de destino.",
  Substituir: "Sustituir",
  Upload_finalizado_com_sucesso: "¡Subida finalizada con éxito!",
  Tamanho_total: "Tamaño total",
  Contem: "Contiene",
  Arquivos: "Archivos",
  Data_de_criacao: "Fecha de creación",
  Permissoes: "Permisos",
  Data_de_validade: "Fecha de validez",
  Indefinida: "Indefinida",
  Senha_de_acesso: "Contraseña de acceso",
  Definir_data_de_validade: "Establecer fecha de validez",
  Definir_uma_senha: "Establecer una contraseña",
  Pastas: "Carpetas",
  Usuarios_com_acesso: "Usuarios con acceso",
  Adicionar_usuarios: "Añadir usuarios",
  Deixar_de_compartilhar: "Dejar de compartir",
  Contatos: "Contactos",
  Pesquisar: "Buscar",
  Pasta_compartilhada_com_sucesso: "¡Carpeta compartida con éxito!",
  Arquivo_compartilhado_com_sucesso: "¡Archivo compartido con éxito!",
  Compartilhamento_removido_com_sucesso: "¡Compartición eliminada con éxito!",
  Editar_pasta: "Editar carpeta",
  Aplicar_alterações_em_sub_pastas_e_arquivos:
    "¡Aplicar cambios en subcarpetas y archivos!",
  Pasta_alterada_com_sucesso: "¡Carpeta cambiada con éxito!",
  Preencha_o_nome_da_pasta: "Rellene el nombre de la carpeta",
  Renomear_Arquivo: "Renombrar archivo",
  Renomear_Pasta: "Renombrar carpeta",
  Novo_nome_do_arquivo: "Nuevo nombre del archivo",
  Novo_nome_da_pasta: "Nuevo nombre de la carpeta",
  Nova_pasta: "Nova pasta",
  Movendo: "Moviendo",
  Itens_selecionados: "Elementos seleccionados",
  Minhas_pastas: "Mis carpetas",
  Pasta_criada_com_sucesso: "¡Carpeta creada con éxito!",
  Pasta_removida_com_sucesso: "¡Carpeta eliminada con éxito!",
  Arquivo_removido_com_sucesso: "¡Archivo eliminado con éxito!",
  Notificacao_deletada_com_sucesso: "¡Notificación eliminada con éxito!",
  Copiado_com_sucesso: "¡Copiado con éxito!",
  Informar_a_data_inicial: "Indicar la fecha inicial",
  Informar_a_data_final: "Indicar la fecha final",
  A_data_inicial_nao_pode_ser_maior_que_a_data_final:
    "La fecha inicial no puede ser mayor que la fecha final",
  Informar_la_fecha_inicial: "Informar la fecha inicial",
  Preencha_o_nome_do_arquivo: "Rellene el nombre del archivo",
  Arquivo_alterado_com_sucesso: "¡Archivo cambiado con éxito!",
  Preencha_o_campo_da_data_de_validade: "Rellene el campo de fecha de validez",
  Data_de_validade_atualizada_com_sucesso:
    "¡Fecha de validez actualizada con éxito!",
  Preencha_o_campo_de_senha: "Rellene el campo de contraseña",
  Senha_atualizada_com_sucesso: "¡Contraseña actualizada con éxito!",
  Link_copiado_com_sucesso: "¡Enlace copiado con éxito!",
  Movido_com_sucesso: "¡Movido con éxito!",
  Arquivo_renomeado_com_sucesso: "¡Archivo renombrado con éxito!",
  Pasta_renomeada_com_sucesso: "¡Carpeta renombrada con éxito!",
  Upload_cancelado_com_sucesso: "¡Subida cancelada con éxito!",
  Item_removido_com_sucesso: "¡Elemento(s) eliminado(s) con éxito!",
  Ocorreu_falha_no_processamento: "¡Ocurrió un error en el procesamiento!",
  Link_removido_com_sucesso: "Enlace removido con éxito!",
  Restaurado_com_sucesso: "Restaurado con éxito!",
  Lixeira_esvaziada_com_sucesso: "Papelera vaciada con éxito!",
  Pasta_criada_com_sucesso: "Carpeta creada con éxito!",
  Links_atualizados_com_sucesso: "Enlaces actualizados con éxito!",
  Notificacao_deletada_com_sucesso: "Notificación eliminada con éxito!",
  Usuario_atualizado_com_sucesso: "Usuario actualizado con éxito!",
  Extensao_nao_tem_suporte_a_visualizacao:
    "Extensión no tiene soporte para visualización",
  Selecione_uma_pasta: "Seleccione una carpeta",
  Selecionar: "Seleccionar",
  Preencha_a_senha_para_acessar_o_conteudo_do_link:
    "Ingrese la contraseña para acceder al contenido del enlace",
  Senha_incorreta: "Contraseña incorrecta",
  Selecione_pasta_ou_arquivo_para_download:
    "Seleccione carpeta o archivo para descargar",
  Selecione_pasta_ou_arquivo_para_mover:
    "Seleccione carpeta o archivo para mover",
  Selecione_pasta_ou_arquivo_para_copiar:
    "Seleccione carpeta o archivo para copiar",
  Selecione_pasta_ou_arquivo_para_remover:
    "Seleccione carpeta o archivo para eliminar",
  Data_do_Descarte: "Fecha de eliminación",
  Restaurar: "Restaurar",
  Atividades_Recentes: "Actividades recientes",
  Ultimas_Notificacoes: "ÚLTIMAS NOTIFICACIONES",
  Deseja_realmente_excluir_a_notificacao:
    "¿Desea realmente eliminar la notificación?",
  Dados_Cadastrais: "Datos registrados",
  Permissoes_de_Visualizacao: "Permisos de visualización",
  Aplicar: "Aplicar",
  Ver_Perfil: "Ver perfil",
  Confirmar_alteracao: "Confirmar cambio",
  Permissoes_Adicionadas: "Permisos agregados",
  Adicionar_Permissoes: "Agregar permisos",
  Nova_Notificacao: "Nueva notificación",
  Cadastradas: "Registradas",
  Armazenamento: "Almacenamiento",
  Utilizacao: "Utilización",
  Nivel_de_acesso: "Nivel de acceso",
  Somente_imagens_nos_formatos_sao_aceitas:
    "Solo se aceptan imágenes en los siguientes formatos:",
  Png_Jgp_E_Jpeg: "PNG, JPG E JPEG. ",
  As_dimensoes_devem_ser_1920_x_324:
    "Las dimensiones deben ser: 1920 x 324 px. ",
  Inativar_Banner: "INACTIVAR BANNER",
  Ativar_Banner: "ACTIVAR BANNER",
  Ordem: "Orden",
  Insira_a_ordem: "Ingrese la orden",
  Link: "Enlace",
  Adicionar_Destinatario: "Agregar destinatario",
  Excluir_Destinatario: "Eliminar destinatario",
  Notificacao: "Notificación",
  Informacoes: "Información",
  Modulos: "Módulos",
  Hora: "Hora",
  Data: "Fecha",
  Informe_o_titulo: "Ingrese el título",
  Informe_o_subtitulo: "Ingrese el subtítulo",
  Informe_o_usuario: "Ingrese el usuario",
  Portal_do_Varejo: "Portal del Varejo",
  Agendar_notificacao: "Agendar notificación",
  Insira_o_titulo: "Ingrese el título",
  Insira_o_subtitulo: "Ingrese el subtítulo",
  Insira_o_link: "Ingrese el enlace",
  Usuarios_com_esta_permissao: "Usuarios con esta permiso",
  Breve_descricao: "Breve descripción",
  Escreva_aqui_uma_breve_descricao_da_permissao:
    "Escriba aquí una breve descripción de la permiso",
  Pastas_com_esta_permissao: "Carpeta con esta permiso",
  Excluir_pasta: "Eliminar carpeta",
  Incluir_subpastas_e_arquivos: "Incluir subcarpetas y archivos",
  Ver_permissao: "Ver permiso",
  Log_de_movimentacao: "Log de movimientos",
  Data_alteracao: "Fecha de alteración",
  Gerar_Relatorio: "Generar reporte",
};
